import FileImageIcon from '@/common/components/svg-icons/FileImageIcon.vue';
import FileWordIcon from '@/common/components/svg-icons/FileWordIcon.vue';
import FilePowerpointIcon from '@/common/components/svg-icons/FilePowerpointIcon.vue';
import FileExcelIcon from '@/common/components/svg-icons/FileExcelIcon.vue';
import FilePdfIcon from '@/common/components/svg-icons/FilePdfIcon.vue';
import FileDocumentOutlineIcon from '@/common/components/svg-icons/FileDocumentOutlineIcon.vue';
import FileIcon from '@/common/components/svg-icons/FileIcon.vue';

export default {
    methods: {
        returnFileIcon(givenFile) {
            let type;
            if (givenFile === 'file') {
                type = this.file.mime_type ? this.file.mime_type.split('/') : this.file.type.split('/');
            } else {
                type =  this.displayFile.mime_type ? this.displayFile.mime_type.split('/') : this.displayFile.type.split('/');
            }

            if (type[0] == 'image') {
                return { component: FileImageIcon, color: 'e3-file'};
            }
            else if(type[0] == 'application') {
                if (type[1].includes('word') || type[1].includes('opendocument.text')) {
                    return { component: FileWordIcon, color: 'e3-word'};
                }
                else if(type[1].includes('powerpoint') || type[1].includes('presentation')) {
                    return { component: FilePowerpointIcon, color: 'e3-powerpoint'};
                }
                else if(type[1].includes('spreadsheet') || type[1].includes('excel')) {
                    return { component: FileExcelIcon, color: 'e3-excel'};
                }
                else if(type[1].includes('pdf')) {
                    return { component: FilePdfIcon, color: 'e3-pdf'};
                }
                return { component: FileIcon, color: 'e3-file'};
            }
            else if(type[0] == 'text') {
                return { component: FileDocumentOutlineIcon, color: 'e3-file'};
            }
            return { component: FileIcon, color: 'e3-file'};
        },
        fileIconComponent(givenFile) {
            return this.returnFileIcon(givenFile).component;
        },
        returnFileSize(bytes, decimals = 2) {
            if (bytes === 0){
                return '0 Bytes';
            }
            const k = 1000;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
    }
};
